import React from 'react'
import './CoursesBannerComponent.css'

const CoursesBannerComponent = () => {
  return (
    <section className='CoursesBannerComponent'>
        <div className='img_holder'>
            <img src='\assets\Image\loan_compare\banner.png' className='banner_img'/>
        </div>
    </section>
  )
}

export default CoursesBannerComponent

